import {useEffect, useState} from "react";
import type {DefaultOptionType} from "antd/es/select";
import useSWR from "swr";
import {api, HydraData} from "../../api/apiProvider";
import urls from "../../api/urls";
import {ReportsFilter} from "./index";

interface Model {
  id: string,
  '@id'?: string,
  name: string,
}

export default function useFiltersData(filter: ReportsFilter) {
  const [poolSearch, setPoolSearch] = useState<string>('');
  const [companySearch, setCompanySearch] = useState<string>('');
  const [productSearch, setProductSearch] = useState<string>('');
  const [poolsOptions, setPoolsOptions] = useState<DefaultOptionType[]>([]);
  const [companiesOptions, setCompaniesOptions] = useState<DefaultOptionType[]>([]);
  const [productsOptions, setProductsOptions] = useState<DefaultOptionType[]>([]);
  const [kpisOptions, setKpisOptions] = useState<DefaultOptionType[]>([]);

  const {
    data: pools,
  } = useSWR<HydraData>(poolSearch ? `${urls.pools}?name=${poolSearch}&pagination=false` : `${urls.pools}?pagination=false`, api.get, {
    revalidateOnFocus: false
  });

  const getCompaniesParamsString = () => {
    const params = new URLSearchParams();

    if (companySearch) {
      params.append('name', companySearch)
    }

    if (filter.pools) {
      for (let pool of filter.pools) {
        params.append('pool.id[]', String(pool.value))
      }
    }

    params.append('pagination', String(false));

    return params.toString()
  };

  const {
    data: companies,
  } = useSWR<HydraData>(`${urls.companies}?${getCompaniesParamsString()}`, api.get, {
    revalidateOnFocus: false
  });

  const getProductsParamsString = () => {
    const params = new URLSearchParams();

    if (productSearch) {
      params.append('name', productSearch)
    }

    if (filter.companies) {
      for (let company of filter.companies) {
        params.append('company.id[]', String(company.value))
      }
    }

    params.append('pagination', String(false));

    return params.toString()
  };

  const {
    data: products,
  } = useSWR<HydraData>(`${urls.products}?${getProductsParamsString()}`, api.get, {
    revalidateOnFocus: false
  });

  const getKpisParamsString = () => {
    const params = new URLSearchParams();

    /*if (productSearch) {
      params.append('name', productSearch)
    }

    if (filter.company) {
      params.append('company.id', String(filter.company.value))
    }

    params.append('pagination', String(false))*/

    return params.toString()
  };

  const {
    data: kpis,
  } = useSWR<HydraData>(`${urls.kpis}?${getKpisParamsString()}`, api.get, {
    revalidateOnFocus: false
  });


  useEffect(() => {
    if (pools && pools.data) {
      setPoolsOptions(pools.data.map((pool: Model) => {
        return {
          value: pool.id,
          label: pool.name,
        }
      }))
    }
  }, [pools]);

  useEffect(() => {
    if (companies && companies.data) {
      setCompaniesOptions(companies.data.map((company: Model) => {
        return {
          value: company.id,
          label: company.name,
        }
      }))
    }
  }, [companies]);

  useEffect(() => {
    if (products && products.data) {
      setProductsOptions(products.data.map((product: Model) => {
        return {
          value: product.id,
          label: product.name,
        }
      }))
    }
  }, [products]);

  useEffect(() => {
    if (kpis && kpis.data) {
      setKpisOptions(kpis.data.map((kpi: Model) => {
        return {
          value: kpi.id,
          label: kpi.name,
        }
      }))
    }
  }, [kpis]);

  return {
    poolsOptions,
    companiesOptions,
    productsOptions,
    kpisOptions,
    setPoolSearch,
    setCompanySearch,
    setProductSearch,
  }
}
